module.exports = __webpack_public_path__ + "img/arh_5.f889fc11.jpg";